export default __webpack_public_path__ + "static/media/see-more.dc464be2.svg";